import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, vModelText as _vModelText, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderSlot as _renderSlot, vShow as _vShow } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "fixed inset-0 bg-gray-900/80 mb-16" }, null, -1)
const _hoisted_2 = { class: "fixed inset-0 flex w-full" }
const _hoisted_3 = { class: "flex grow flex-col overflow-y-auto bg-white px-6 pb-4 dark:bg-black/10 dark:ring-1 dark:ring-white/10 pt-10" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "h-full space-y-6" }
const _hoisted_6 = { class: "pb-8" }
const _hoisted_7 = {
  key: 1,
  class: "min-h-full flex flex-col gap-y-5 group/sidebar relative"
}
const _hoisted_8 = {
  class: /*#__PURE__*/_normalizeClass(['md:w-[409px] h-full hidden md:fixed md:inset-y-0 md:z-50 md:flex md:flex-col transition-all duration-200 ease-in-out shadow-lg border-r border-zinc-200'])
}
const _hoisted_9 = { class: "flex h-full min-h-0 flex-col bg-white group/sidebar overflow-x-scroll" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { class: "flex flex-col justify-center h-16 px-6" }
const _hoisted_12 = { class: "text-xl font-semibold" }
const _hoisted_13 = { class: "space-y-6 flex flex-1 flex-col overflow-y-auto px-12 pb-4" }
const _hoisted_14 = { class: "px-6 mt-4 pb-6" }
const _hoisted_15 = { class: "text-xl font-semibold" }
const _hoisted_16 = {
  key: 1,
  class: "min-h-full flex flex-col gap-y-5 bg-white px-6 pt-4 pb-16 md:pb-24 group/sidebar relative"
}
const _hoisted_17 = {
  key: 0,
  class: "border-t border-zinc-900/10 px-6 py-4 bg-white flex flex-col pb-28"
}
const _hoisted_18 = { class: "flex justify-between items-center gap-6" }
const _hoisted_19 = {
  key: 1,
  class: "border-t border-zinc-900/10 px-6 py-4 bg-white flex flex-col pb-28"
}
const _hoisted_20 = { class: "flex justify-between items-center gap-6" }
const _hoisted_21 = {
  class: /*#__PURE__*/_normalizeClass(['md:pl-[409px] transition-all duration-200 ease-in-out'])
}
const _hoisted_22 = { class: "bg-gray-50 dark:bg-gray-900 h-screen" }
const _hoisted_23 = { class: "h-full" }
const _hoisted_24 = { class: "min-h-full" }
const _hoisted_25 = { class: "md:hidden fixed w-full bottom-0 z-50 flex h-16 shrink-0 items-center gap-x-4 border-b border-gray-200 bg-white px-4 shadow-sm sm:gap-x-6 sm:px-6 md:px-8 dark:border-white/5 dark:bg-gray-900 justify-start" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Open sidebar", -1)

import AdditionalInfo from '@/modules/search/components/AdditionalInfo.vue'
	import PageFooter from '@/components/PageFooter.vue'
	import SceneCard from '@/modules/scene/SceneCard.vue'
	
	// Headless UI
	import {
		Dialog,
		DialogPanel,
		Menu,
		MenuItem,
		TransitionChild,
		TransitionRoot,
	} from '@headlessui/vue'

	// Language
	import {
		useI18n
	} from 'vue-i18n'

	// Store
	import { 
		store as _jobStore
	} from '@/store/job'
	import {
		localesStore as _localesStore
	} from '@/store/locales'

	// Vue
	import {
		computed,
		ref,
		watch
	} from 'vue'

	
	const __default__ = { name: 'SidebarWithHeader' } // name the component

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

	
	// Components
	const {t} = useI18n()
	const jobStore = _jobStore()
	const localesStore = _localesStore()

	const showScenes = ref<boolean>(true)
	const showAdditionalInfo = ref<boolean>(false)

	function displayScenes() {
		showAdditionalInfo.value = false
		showScenes.value = true
	}

	function displayAdditionalInfo() {
		showScenes.value = false
		showAdditionalInfo.value = true
	}

	const sceneList = computed(() => {
		return jobStore.job?.jobDetails?.scenes
	})
	const numScenes = ref(sceneList?.value?.length)
	const numScenesWithSong = ref(sceneList?.value?.filter(scene => scene['job__JOBS_SCENES__jobID::zctSongID'] !== '')?.length)

	watch(jobStore.job?.jobDetails?.scenes, () => {
		numScenesWithSong.value = sceneList?.value?.filter(scene => scene['job__JOBS_SCENES__jobID::zctSongID'] !== '')?.length
	})
  
	const sidebarOpen = ref(false)

	const addtlInfo = ref(null)
	// const loading = ref(false)

  
return (_ctx: any,_cache: any) => {
  const _component_v_label = _resolveComponent("v-label")!
  const _component_v_field = _resolveComponent("v-field")!
  const _component_tw_button = _resolveComponent("tw-button")!
  const _component_v_text = _resolveComponent("v-text")!
  const _component_ChevronUpIcon = _resolveComponent("ChevronUpIcon")!
  const _component_ChevronDownIcon = _resolveComponent("ChevronDownIcon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _createVNode(_unref(TransitionRoot), {
        as: "template",
        show: sidebarOpen.value
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(Dialog), {
            as: "div",
            class: "relative z-50 md:hidden",
            onClose: _cache[3] || (_cache[3] = ($event: any) => (sidebarOpen.value = false))
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(TransitionChild), {
                as: "template",
                enter: "transition-opacity ease-linear duration-300",
                "enter-from": "opacity-0",
                "enter-to": "opacity-100",
                leave: "transition-opacity ease-linear duration-300",
                "leave-from": "opacity-100",
                "leave-to": "opacity-0"
              }, {
                default: _withCtx(() => [
                  _hoisted_1
                ]),
                _: 1
              }),
              _createElementVNode("div", _hoisted_2, [
                _createVNode(_unref(TransitionChild), {
                  as: "template",
                  enter: "transition ease-in-out duration-300 transform",
                  "enter-from": "translate-y-full",
                  "enter-to": "-translate-y-0",
                  leave: "transition ease-in-out duration-300 transform",
                  "leave-from": "-translate-y-0",
                  "leave-to": "translate-y-full"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(DialogPanel), { class: "relative my-16 flex w-full flex-1 dark:bg-gray-900" }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_3, [
                          (showScenes.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                                _createElementVNode("div", _hoisted_5, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sceneList.value, (scene, i) => {
                                    return (_openBlock(), _createBlock(SceneCard, {
                                      key: i,
                                      "array-index": i,
                                      scene: scene
                                    }, null, 8, ["array-index", "scene"]))
                                  }), 128)),
                                  _createVNode(_component_v_field, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_label, null, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(_unref(t)('sidebar.notes')), 1)
                                        ]),
                                        _: 1
                                      }),
                                      (_unref(localesStore).locales.selected === 'ja')
                                        ? _withDirectives((_openBlock(), _createElementBlock("textarea", {
                                            key: 0,
                                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(jobStore).job.jobDetails.notesKanji) = $event)),
                                            "aria-label": "メモ",
                                            class: "focus:ring-teal-500 focus:boder-1 focus:border-teal-500 rounded-md border-zinc-300 w-full mt-1 text-base/6 text-zinc-950 placeholder:text-zinc-500 sm:text-sm/6",
                                            rows: "3",
                                            name: "notes"
                                          }, null, 512)), [
                                            [_vModelText, _unref(jobStore).job.jobDetails.notesKanji]
                                          ])
                                        : (_unref(localesStore).locales.selected === 'kana')
                                          ? _withDirectives((_openBlock(), _createElementBlock("textarea", {
                                              key: 1,
                                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(jobStore).job.jobDetails.notesKana) = $event)),
                                              "aria-label": "メモ",
                                              class: "focus:ring-teal-500 focus:boder-1 focus:border-teal-500 rounded-md border-zinc-300 w-full mt-1 text-base/6 text-zinc-950 placeholder:text-zinc-500 sm:text-sm/6",
                                              rows: "3",
                                              name: "notes"
                                            }, null, 512)), [
                                              [_vModelText, _unref(jobStore).job.jobDetails.notesKana]
                                            ])
                                          : _withDirectives((_openBlock(), _createElementBlock("textarea", {
                                              key: 2,
                                              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(jobStore).job.jobDetails.notesEnglish) = $event)),
                                              "aria-label": "Notes",
                                              class: "focus:ring-teal-500 focus:boder-1 focus:border-teal-500 rounded-md border-zinc-300 w-full mt-1 text-base/6 text-zinc-950 placeholder:text-zinc-500 sm:text-sm/6",
                                              rows: "3",
                                              name: "notes"
                                            }, null, 512)), [
                                              [_vModelText, _unref(jobStore).job.jobDetails.notesEnglish]
                                            ])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _createElementVNode("div", _hoisted_6, [
                                  _createVNode(_component_tw_button, {
                                    disabled: _unref(jobStore).job.jobDetails.hasHadSongsSubmitted,
                                    onClick: displayAdditionalInfo,
                                    class: "btn-brand font-medium w-full"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_unref(t)('welcome.continueButton')), 1)
                                    ]),
                                    _: 1
                                  }, 8, ["disabled"])
                                ])
                              ]))
                            : (showAdditionalInfo.value)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                                  _createVNode(AdditionalInfo, {
                                    onNavigateBack: displayScenes,
                                    ref_key: "addtlInfo",
                                    ref: addtlInfo
                                  }, null, 512)
                                ]))
                              : _createCommentVNode("", true)
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["show"])
    ]),
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          (showScenes.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("h1", _hoisted_12, _toDisplayString(_unref(t)('nav.sidebarTitle')), 1)
                ]),
                _createElementVNode("div", _hoisted_13, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sceneList.value, (scene, i) => {
                    return (_openBlock(), _createElementBlock("div", { key: i }, [
                      _createVNode(SceneCard, {
                        ref_for: true,
                        ref: "sceneCard",
                        "array-index": i,
                        scene: scene
                      }, null, 8, ["array-index", "scene"])
                    ]))
                  }), 128))
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("h2", _hoisted_15, _toDisplayString(_unref(t)('sidebar.notes')), 1),
                  _createVNode(_component_v_field, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_label, { class: "sr-only" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(t)('sidebar.notes')), 1)
                        ]),
                        _: 1
                      }),
                      (_unref(localesStore).locales.selected === 'ja')
                        ? _withDirectives((_openBlock(), _createElementBlock("textarea", {
                            key: 0,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(jobStore).job.jobDetails.notesKanji) = $event)),
                            "aria-label": "メモ",
                            class: "focus:ring-teal-500 focus:boder-1 focus:border-teal-500 rounded-md border-zinc-300 w-full mt-1 text-base/6 text-zinc-950 placeholder:text-zinc-500 sm:text-sm/6",
                            rows: "3",
                            name: "notes"
                          }, null, 512)), [
                            [_vModelText, _unref(jobStore).job.jobDetails.notesKanji]
                          ])
                        : (_unref(localesStore).locales.selected === 'kana')
                          ? _withDirectives((_openBlock(), _createElementBlock("textarea", {
                              key: 1,
                              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(jobStore).job.jobDetails.notesKana) = $event)),
                              "aria-label": "メモ",
                              class: "focus:ring-teal-500 focus:boder-1 focus:border-teal-500 rounded-md border-zinc-300 w-full mt-1 text-base/6 text-zinc-950 placeholder:text-zinc-500 sm:text-sm/6",
                              rows: "3",
                              name: "notes"
                            }, null, 512)), [
                              [_vModelText, _unref(jobStore).job.jobDetails.notesKana]
                            ])
                          : _withDirectives((_openBlock(), _createElementBlock("textarea", {
                              key: 2,
                              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(jobStore).job.jobDetails.notesEnglish) = $event)),
                              "aria-label": "Notes",
                              class: "focus:ring-teal-500 focus:boder-1 focus:border-teal-500 rounded-md border-zinc-300 w-full mt-1 text-base/6 text-zinc-950 placeholder:text-zinc-500 sm:text-sm/6",
                              rows: "3",
                              name: "notes"
                            }, null, 512)), [
                              [_vModelText, _unref(jobStore).job.jobDetails.notesEnglish]
                            ])
                    ]),
                    _: 1
                  })
                ])
              ]))
            : (showAdditionalInfo.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                  _createVNode(AdditionalInfo, {
                    onNavigateBack: displayScenes,
                    ref_key: "addtlInfo",
                    ref: addtlInfo
                  }, null, 512)
                ]))
              : _createCommentVNode("", true)
        ]),
        (showScenes.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, [
                _createVNode(_component_v_text, { class: "w-full" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(numScenesWithSong.value) + " / " + _toDisplayString(numScenes.value) + " " + _toDisplayString(_unref(t)('scene.songsSelected')), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_tw_button, {
                  disabled: _unref(jobStore).job.jobDetails.hasHadSongsSubmitted,
                  onClick: displayAdditionalInfo,
                  class: "btn-brand font-medium w-full"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('welcome.continueButton')), 1)
                  ]),
                  _: 1
                }, 8, ["disabled"])
              ])
            ]))
          : _createCommentVNode("", true),
        (showAdditionalInfo.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
              _createElementVNode("div", _hoisted_20, [
                _createVNode(_component_tw_button, {
                  onClick: displayScenes,
                  class: "font-medium w-full",
                  "class-name": "text-blue-500",
                  loading: addtlInfo.value?.loading
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('sidebar.back')), 1)
                  ]),
                  _: 1
                }, 8, ["loading"]),
                _createVNode(_component_tw_button, {
                  onClick: _cache[7] || (_cache[7] = () => addtlInfo.value?.navigateNext()),
                  class: "btn-brand font-medium w-full",
                  disabled: !addtlInfo.value?.submissionConfirmation,
                  loading: addtlInfo.value?.loading
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('sidebar.submit')), 1)
                  ]),
                  _: 1
                }, 8, ["disabled", "loading"])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_21, [
        _createElementVNode("main", _hoisted_22, [
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("div", _hoisted_24, [
              _renderSlot(_ctx.$slots, "default")
            ]),
            _createVNode(PageFooter, { class: "flex flex-col pb-24" })
          ])
        ]),
        _createElementVNode("div", _hoisted_25, [
          _createVNode(_component_v_text, { class: "max-md:hidden" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(numScenesWithSong.value) + " / " + _toDisplayString(numScenes.value) + " " + _toDisplayString(_unref(t)('scene.songsSelected')), 1)
            ]),
            _: 1
          }),
          _createElementVNode("button", {
            type: "button",
            class: "-m-2.5 p-2.5 text-gray-700 md:hidden flex items-center gap-2",
            onClick: _cache[8] || (_cache[8] = ($event: any) => (sidebarOpen.value = true))
          }, [
            _hoisted_26,
            _createVNode(_component_v_text, null, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(numScenesWithSong.value) + " / " + _toDisplayString(numScenes.value) + " " + _toDisplayString(_unref(t)('scene.songsSelected')), 1)
              ]),
              _: 1
            }),
            _withDirectives(_createVNode(_component_ChevronUpIcon, {
              class: "h-6 w-6",
              "aria-hidden": "true"
            }, null, 512), [
              [_vShow, !sidebarOpen.value]
            ]),
            _withDirectives(_createVNode(_component_ChevronDownIcon, {
              class: "h-6 w-6",
              "aria-hidden": "true"
            }, null, 512), [
              [_vShow, sidebarOpen.value]
            ])
          ])
        ])
      ])
    ])
  ], 64))
}
}

})